// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1MKNL","header":"ClearentDisclaimer_header__oGyUT","inner":"ClearentDisclaimer_inner__36FIc"};